export const BUDGET_MANAGER_COLUMNS = {
    budget_manager_status: 'budget_manager_status',
    bid_manager_status: 'bid_manager_status',
    monthly_budget: 'monthly_budget',
    daily_budget_cluster: 'daily_budget_cluster',
    minimum_performance_value: 'minimum_performance_value',
    minimum_daily_budget_value: 'minimum_daily_budget_value',
    pace_budget: 'pace_budget',
    pace_target: 'pace_target',
    performance_window: 'performance_window',
    days_between_adjustments_budget: 'days_between_adjustments_budget',
    days_between_adjustments_target: 'days_between_adjustments_target',
    projected_cost: 'projected_cost',
    projected_revenue: 'projected_revenue',
    projected_conversions: 'projected_conversions',
    projected_clicks: 'projected_clicks',
};
